var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('on-click-outside',{attrs:{"do":_vm.hide}},[_c('div',{staticClass:"hint is-hidden-print"},[_vm._v(" Для просмотра информации щелкните на карте. ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }